// 三维模型
export default [
  //模型库首页
  {
    path: "/:lang/ModeLibrary/Index",
    name: "ModeLibrary",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/ModeLibrary/index.vue"),
  },
  //客户端使用
  {
    path: "/:lang/ModeLibrary/DesktopClient/Index",
    name: "ModeLibraryDesktopClientIndex",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/ModeLibrary/DesktopClient/Index.vue"),
  },
  //客户端使用
  {
    path: "/:lang/ModeLibrary/DesktopClient/Detail",
    name: "ModeLibraryDesktopClientDetail",
    meta: {
      title: "",
      cache: false,
      noFrame: true,
      noPermissionValidate: true,
      keepAlive: true,
      isLoaded: false,
    },
    component: () => import("/@/views/ModeLibrary/DesktopClient/Detail.vue"),
  },
];
